import { ConfigType } from '../utils/requestAPI';

type GetNotificationsParamsType = {
  page?: number;
  limit?: number;
  filterDate?: string;
};
const notificationsApi = {
  getAllNotifications: ({
    action,
    params,
  }: {
    action: 'set' | 'update';
    params: GetNotificationsParamsType;
  }): ConfigType => {
    return {
      url: '/notifications/all',
      method: 'get',
      params,
      config: { store: { action, key: 'notifications.data' } },
    };
  },
  readNotifications: (notificationIds: {
    notificationId: string[];
  }): ConfigType => {
    return {
      url: '/notifications/mark-as-read',
      method: 'patch',
      data: notificationIds,
    };
  },
};

export default notificationsApi;
